import React from "react";

import * as DetailList from "~/components/DetailList";
import Skeleton from "~/components/Skeleton";
import { VASP, VASPCertificate } from "~/types/vaspid";

const EMPTY = "-";

export default function VASPCertificates({ vasp }: { vasp?: VASP | null }) {
  const certificates: VASPCertificate[] = vasp?.certificates ? JSON.parse(vasp.certificates) : [];

  return (
    <div>
      <DetailList.Header>
        <DetailList.Item mobile={12}>
          <DetailList.Title as="h2">{`Memberships & Certificates`}</DetailList.Title>
        </DetailList.Item>
      </DetailList.Header>
      {vasp && certificates.length === 0 && <p>No certificates, yet</p>}
      {vasp &&
        certificates.map((certificate, i) => (
          <DetailList.Content key={i}>
            {[{ label: "Type", value: certificate["type"] }].map(({ label, value }) => (
              <DetailList.Item key={label} mobile={12}>
                <DetailList.Term>{label}</DetailList.Term>
                <DetailList.Description className="localize-ignore">{value || EMPTY}</DetailList.Description>
              </DetailList.Item>
            ))}
          </DetailList.Content>
        ))}
      {!vasp && <Skeleton count={2} />}
    </div>
  );
}
